window.addEventListener("load", () => {
  const fonts = new Map();

  document.querySelectorAll(
    "h1,h2,h3,h4,h5,h6,p,span,a,button,label,li,input,textarea,strong,small"
  ).forEach((el) => {
    const text = el.innerText?.trim();

    if (!text) return;

    const font = getComputedStyle(el).fontFamily;

    if (!font) return;

    const fontName = font.trim();

    if (!fonts.has(fontName)) {
      fonts.set(fontName, []);
    }

    fonts.get(fontName).push({
      tag: el.tagName.toLowerCase(),
      className: el.className,
      text: text.substring(0, 60)
    });
  });

  console.clear();

  console.log("=========== FONTS ===========");

  fonts.forEach((items, font) => {
    console.group(font);

    items.slice(0, 10).forEach(item => {
      console.log(
        `<${item.tag}> class="${item.className}"`,
        "→",
        item.text
      );
    });

    console.groupEnd();
  });

  console.log(`Total Unique Fonts: ${fonts.size}`);
});